import { FormControl, FormGroup } from "@angular/forms";

export class FormHelper {

  /**
   * Change all empty value to null in form
   * @param form the form (FormGroup)
   * eg: {a:'', b:undefined, c:'foo'}
   *  => {a:null, b:null, c:'foo'}
   */
  static allEmptyFieldToNull(form: FormGroup) {
    Object.keys(form.value).forEach((key: string) => {
      if(form.value[key] === '') {
        form.get(key).setValue(null);
      }
    });
  }

  static allFormIsEmpty(form: FormGroup): boolean {
    let found = true;
    Object.keys(form.value).forEach((key: string) => {
      const r = form.value[key];
      if(form.value[key]) {
        found = false;
      }
    });
    return found;
  }
  static allFormIsEmpty2(object: any) {
    let found = true;
    const sreachValue = object instanceof FormGroup ? object.value : object;
    Object.keys(sreachValue).forEach((key: string) => {
      const val = sreachValue[key];
      if (val !== null && typeof val === 'object') {
        const result = FormHelper.allFormIsEmpty2(val);
        if (result) {
          found = false;
        }
      } else {
        if (!FormHelper.formKeyIsEmpty(val)) {
          found = false;
        }
      }
    });
    return found
  }

  static formKeyIsEmpty(val: any): boolean {
    if(val) {
      return false;
    }
    return true;
  }

  static allFormContorlIsEmpty(form: FormControl): boolean {
    let found = true;
    if(!form.value) {
      return true;
    }
    Object.keys(form.value).forEach((key: string) => {
      const r = form.value[key];
      if(form.value[key]) {
        found = false;
      }
    });
    return found;
  }

  static setFcNullIfAllEmpty(form: FormControl) {
    if(this.allFormContorlIsEmpty(form)) {
      form.setValue(null);
    }
  }
}
